import { clearSubSection }                 from 'dmpconnectjsapp-base/actions';
import { formatSearchFhirHealthDirectory } from 'dmpconnectjsapp-base/actions/config/commandParamsFormatters';
import commands                            from 'dmpconnectjsapp-base/actions/config/commands';
import { apiSections }                     from 'dmpconnectjsapp-base/constants';
import { getInteropCodesFromState }        from 'dmpconnectjsapp-base/helpers/accessors';
import { hasError, isLoading, isReady }    from 'dmpconnectjsapp-base/helpers/common';
import { fhirToHp }                        from 'dmpconnectjsapp-base/utils/fhir';
import * as PropTypes                      from 'prop-types';
import React                               from 'react';
import { AsyncTypeahead }                  from 'react-bootstrap-typeahead';
import { connect }                         from 'react-redux';
import { getAction }                       from '../../dmpconnect/actions';

const FhirAsyncTypeAhead = ({
  dispatch,
  value,
  onChange,
  fhirResult,
  subSection,
  isInvalid,
  id,
  name,
  multiple,
  professions,
  disabled,
}) => {
  const ref                 = React.useRef();
  const [search, setSearch] = React.useState('');
  
  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (search) {
        dispatch(clearSubSection(apiSections.FHIR_SEARCH, subSection));
        const [name, given] = search.trim().split(' ');
        dispatch(getAction(
          commands.searchFhirHealthDirectory,
          apiSections.FHIR_SEARCH,
          formatSearchFhirHealthDirectory({
            name,
            given,
          }),
          {
            subSection,
          },
        ));
      }
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [search]);
  
  const searchRecipients = (query) => {
    if (query.trim().length >= 2) {
      setSearch(query);
    }
  };
  
  const list = React.useMemo(() => {
    if (isReady(fhirResult)) {
      return fhirResult.PsList
        .filter(ps => Object.keys(ps.Organization || {}).length > 0 && ps.i_isActive === 1)
        .map(ps => fhirToHp(ps, professions));
    } else if (hasError(fhirResult)) {
      return [];
    } else {
      return [];
    }
  }, [fhirResult, professions]);
  
  return (
    <>
      <AsyncTypeahead
        useCache={false}
        inputProps={{ className: 'form-control-sm' }}
        className="custom-typeahead"
        ref={ref}
        id={id}
        isLoading={isLoading(fhirResult)}
        labelKey={option => `${option.s_hpName} ${option.s_hpGiven || ''}`}
        minLength={3}
        onSearch={searchRecipients}
        selected={list.filter(hp => value.some(shp => hp.s_hpInternalId === shp.s_hpInternalId))}
        options={list}
        placeholder="Rechercher un PS ..."
        searchText="Recherche en cours ..."
        emptyLabel="Aucun résultat"
        isInvalid={isInvalid}
        disabled={disabled}
        onChange={selection => {
          if (!!selection) {
            onChange({
              target: {
                value: multiple ? selection : selection[0],
                name,
              }
            });
          } else {
            onChange({
              target: {
                value: {},
                name,
              }
            });
          }
        }}
        renderMenuItemChildren={(option, { text }, index) => (
          <div className="d-flex flex-column mss-recipients">
            <div className="d-flex align-items-center mss-recipient-name">
              <span className={`mr-1 badge-profession badge-profession-${option.s_hpProfession}-1`}/>
              {option.s_hpName}
              {' '}
              {option.s_hpGiven}
            </div>
            <div className="mss-recipient-email">
              <small className="text-gray-400">
                {option.s_hpProfessionDescription}
                {option.s_hpSpecialtyDescription ? `, ${option.s_hpSpecialtyDescription}` : ''}
              </small>
            </div>
            {option.s_idNat && (
              <div className="d-flex align-items-center mss-recipient-idNat">
                <small className="text-gray-400">
                  Id. Nat. :
                  {' '}
                  {option.s_hpInternalId}
                </small>
              </div>
            )}
          </div>
        )}
      />
    </>
  );
};

function mapStateToProps(state, props) {
  const
    {
      dmpconnect: {
        [apiSections.FHIR_SEARCH]: {
          [props.subSection]: fhirResult,
        } = {},
      },
    } = state;
  
  return {
    fhirResult,
    professions: getInteropCodesFromState(state, 'professions'),
  };
}

FhirAsyncTypeAhead.propTypes = {
  dispatch            : PropTypes.func.isRequired,
  value               : PropTypes.array,
  onChange            : PropTypes.func.isRequired,
  fhirResult          : PropTypes.object,
  subSection          : PropTypes.string.isRequired,
  isInvalid           : PropTypes.bool,
  multiple            : PropTypes.bool,
  labelKey            : PropTypes.string,
  id                  : PropTypes.string.isRequired,
  name                : PropTypes.string.isRequired,
  categoriesProfession: PropTypes.object,
  professions         : PropTypes.array.isRequired,
  disabled            : PropTypes.bool,
};

FhirAsyncTypeAhead.defaultProps = {
  value               : [],
  fhirResult          : {},
  isInvalid           : false,
  multiple            : true,
  labelKey            : 's_name',
  categoriesProfession: undefined,
  disabled            : false,
};

export default connect(mapStateToProps)(FhirAsyncTypeAhead);
